import { formDataFromQueryString } from 'Shared/Helper/FormData/CreateFromQueryString';
import { queryStringFromObject } from 'Shared/Helper/QueryString/CreateFromObject';

export function formDataFromObject (object) {
    const queryString = queryStringFromObject(object);

    return formDataFromQueryString(queryString);
}
